import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/sign/kakao-redirect")({
  component: RouteComponent,
});

function RouteComponent() {
  return <div>Hello "/auth/kakao-redirect"!</div>;
}
